// Do-not-contact list (Settings): an address or a whole domain. Blocks drafts, approval and
// "sent" records for every prospect.
import { useState } from 'react';
import { Empty, ErrorMsg, Section, Time } from '../../components/ui';
import { api, errorText } from '../../lib/api';
import type { SuppressionRow } from '../../lib/prospectTypes';
import { useApi, useSession } from '../../lib/session';

export function Suppressions() {
  const list = useApi<{ items: SuppressionRow[] }>('/api/suppressions');
  const { user } = useSession();
  const [f, setF] = useState({ kind: 'email', value: '', reason: '' });
  const [err, setErr] = useState('');
  async function add(e: React.FormEvent) {
    e.preventDefault();
    setErr('');
    try {
      await api('/api/suppressions', { body: f });
      setF({ ...f, value: '', reason: '' });
      list.reload();
    } catch (e2) {
      setErr(errorText(e2));
    }
  }
  async function remove(id: string) {
    try {
      await api(`/api/suppressions/${id}/remove`, { method: 'POST' });
      list.reload();
    } catch (e) {
      setErr(errorText(e));
    }
  }
  return (
    <Section title="Do not contact" id="suppressions">
      <p className="small">Addresses and domains that must never receive outreach (opt-outs, bounces, your decision). Applies to every prospect.</p>
      {list.data && list.data.items.length === 0 && <Empty>The list is empty.</Empty>}
      <ul className="plain small">
        {(list.data?.items ?? []).map((s) => (
          <li key={s.id}>
            {s.kind} <strong>{s.value}</strong> · {s.reason} · <Time iso={s.created_at} />
            {user?.role === 'owner' && (
              <>
                {' '}
                <button type="button" className="btn small ghost" onClick={() => void remove(s.id)}>
                  Remove
                </button>
              </>
            )}
          </li>
        ))}
      </ul>
      <form className="form-grid" aria-label="Add to do-not-contact" onSubmit={add}>
        <label className="field">
          <span>Kind</span>
          <select value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })}>
            <option value="email">email address</option>
            <option value="domain">whole domain</option>
          </select>
        </label>
        <label className="field">
          <span>Value</span>
          <input value={f.value} onChange={(e) => setF({ ...f, value: e.target.value })} />
        </label>
        <label className="field span2">
          <span>Reason</span>
          <input value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} />
        </label>
        <div className="span2">
          <button type="submit" className="btn small" disabled={!f.value.trim() || !f.reason.trim()}>
            Add
          </button>
        </div>
      </form>
      <ErrorMsg>{err || list.error}</ErrorMsg>
    </Section>
  );
}
